import React from 'react';
import { Zap } from 'lucide-react';
import { useCountdown } from './useCountdown';
export function UrgencyBanner() {
  const {
    formattedTime
  } = useCountdown();
  return <div className="sticky top-0 z-50 bg-[#e8a365] text-white py-3 px-4 shadow-md" data-id="element-240">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-center font-medium text-sm sm:text-base" data-id="element-241">
        <span className="flex items-center gap-1" data-id="element-242">
          <Zap size={18} className="fill-white" data-id="element-243" />
          OFERTA ESPECIAL SOLO POR HOY
        </span>
        <span className="hidden sm:inline" data-id="element-244">—</span>
        <span className="font-bold bg-white/20 px-3 py-1 rounded-md tracking-wider" data-id="element-245">
          Finaliza en: {formattedTime}
        </span>
      </div>
    </div>;
}